import { StoreImageEnum } from '@systemeio/digital-store-shared'
import { FormInput } from '@systemeio/ui'
import StoreFields from 'modules/stores/store/components/contact-fields'
import ItemSteps from 'modules/stores/store/components/item-steps'
import StoreImageSelector from 'modules/stores/store/components/store-image-selector'
import { StoreTextEditor } from 'modules/stores/store/components/store-text-editor'
import {
  PhysicalProductItemEditType,
  PhysicalProductItemErrorsType,
} from 'modules/stores/store/content/product/types/product-interface'
import { Dispatch, SetStateAction } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import PaymentMethodsEditModal from '../../components/payment-methods-edit-modal'
import { twJoin } from 'tailwind-merge'
import { physicalProductInitFields } from '../constants/mandatory-fields'

interface PhysicalCheckoutProps {
  tempState: PhysicalProductItemEditType
  setTempState: Dispatch<SetStateAction<PhysicalProductItemEditType>>
  errors: PhysicalProductItemErrorsType
  imageType: StoreImageEnum
}

export const PhysicalCheckout = ({
  tempState,
  setTempState,
  errors,
  imageType,
}: PhysicalCheckoutProps) => {
  const { t } = useLocoTranslation()

  return (
    <ItemSteps
      steps={[
        {
          key: 'image',
          title: t('dashboard.store.image.select_image'),
          element: (
            <StoreImageSelector
              dataFile={tempState.checkoutPage.cover}
              imageType={imageType}
              label={t('dashboard.store.product.checkout_image_label')}
              onChange={dataFile =>
                setTempState(prev => ({
                  ...prev,
                  checkoutPage: {
                    ...prev.checkoutPage,
                    cover: dataFile,
                  },
                }))
              }
            />
          ),
        },
        {
          key: 'text',
          title: t('dashboard.store.item.add_text'),
          element: (
            <div className={'flex flex-col gap-5'}>
              <div className={'grid grid-cols-1 gap-5 sm:grid-cols-2'}>
                <FormInput
                  required
                  value={tempState.checkoutPage.title}
                  label={t('dashboard.store.item.title')}
                  onChange={({ target: { value } }) =>
                    setTempState(prev => ({
                      ...prev,
                      checkoutPage: { ...prev.checkoutPage, title: value },
                    }))
                  }
                  error={errors['checkoutPage.title']}
                />
                <FormInput
                  required
                  value={tempState.checkoutPage.buttonTitle}
                  label={t('dashboard.store.item.button')}
                  onChange={({ target: { value } }) =>
                    setTempState(prev => ({
                      ...prev,
                      checkoutPage: { ...prev.checkoutPage, buttonTitle: value },
                    }))
                  }
                  error={errors['checkoutPage.buttonTitle']}
                />
              </div>
              <StoreTextEditor
                label={t('dashboard.store.item.description')}
                required
                content={tempState.checkoutPage.description}
                onChange={value =>
                  setTempState(prev => ({
                    ...prev,
                    checkoutPage: {
                      ...prev.checkoutPage,
                      description: value,
                    },
                  }))
                }
                className={twJoin(errors['checkoutPage.description'] && 'border-danger')}
                error={errors['checkoutPage.description']}
              />
            </div>
          ),
        },
        {
          key: 'fields',
          title: t('dashboard.store.item.collect_info'),
          element: (
            <StoreFields
              fields={tempState.checkoutPage.fields}
              onChange={fields =>
                setTempState(prev => ({ ...prev, checkoutPage: { ...prev.checkoutPage, fields } }))
              }
              initFields={physicalProductInitFields}
              error={errors['checkoutPage.fields']}
            />
          ),
        },
        {
          key: 'payment methods',
          title: t('dashboard.store.product.checkout.payment_methods'),
          element: (
            <PaymentMethodsEditModal
              errors={{ paymentMethods: errors['digitalStore.paymentMethods'] }}
            />
          ),
        },
      ]}
    />
  )
}
